import React from 'react';
import { MapPin } from 'lucide-react';
import HeroCarousel from '../HeroCarousel';

/**
 * Section Hero de l'accueil : carrousel CMS (`/api/carousel`) avec repli sur le
 * hero « Culte du Dimanche » quand le carrousel est vide. Extrait de HomeScreen.
 */
const MAPS_URL = 'https://www.google.com/maps/dir/?api=1&destination=7+Rue+Pascal,+93120+La+Courneuve';

function SundayHeroFallback() {
  return (
    <div
      className="relative w-full aspect-[4/5] md:aspect-[16/9] max-h-[560px] overflow-hidden cursor-pointer"
      onClick={() => window.open(MAPS_URL, '_blank')}
      role="link"
      tabIndex={0}
      onKeyDown={(e) => { if (e.key === 'Enter') window.open(MAPS_URL, '_blank'); }}
      data-testid="sunday-banner"
    >
      <img
        src="https://images.unsplash.com/photo-1519834785169-98be25ec3f84?w=800&q=80&auto=format"
        alt="Culte du Dimanche"
        className="absolute inset-0 w-full h-full object-cover"
        width={2000}
        height={1600}
        fetchPriority="high"
        decoding="async"
      />
      <div className="absolute top-0 left-0 right-0 z-10 pointer-events-none pcc-status-bar-gradient" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" />
      <div className="absolute bottom-0 left-0 right-0 p-8 md:p-12 text-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-5xl font-bold mb-3 tracking-tight">CULTE DU DIMANCHE</h2>
          <p className="text-lg md:text-xl text-white/90 mb-4 tracking-wide">10h00 et 16h00 • 7 Rue Pascal, La Courneuve</p>
          <span className="inline-flex items-center gap-1.5 text-sm text-white/70 hover:text-white transition-colors">
            <MapPin size={14} />
            Voir l'itinéraire
          </span>
        </div>
      </div>
    </div>
  );
}

export default function HeroSection() {
  return <HeroCarousel fallback={<SundayHeroFallback />} />;
}
